import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import type {ItemViewHeroImage} from '../components';
import type {IBeginAnimationToItemViewParams} from '../services';

export type TItemViewHeroImageProps = Pick<IBeginAnimationToItemViewParams, 'heroImagePath' | 'transitionEndCallback'>;

@Module({name: 'animation', namespaced: true})
export class AnimationModule extends VuexModule {
	itemViewHeroImageProps: TItemViewHeroImageProps | null = null;
	itemViewHeroImageRef: ItemViewHeroImage | null = null;
	splashScreenHidden = false;

	@Mutation
	setItemViewHeroImageProps(params: TItemViewHeroImageProps | null) {
		if(!params?.heroImagePath) {
			throw new Error('No hero image provided.');
		}
		this.itemViewHeroImageProps = {...params};
	}

	@Mutation
	setItemViewHeroImageRef(ref: ItemViewHeroImage | null) {
		this.itemViewHeroImageRef = ref;
	}

	@Mutation
	setSplashScreenHidden() {
		this.splashScreenHidden = true;
	}
}
